import React, { useState } from 'react';
import Title from '../../../app/components/Title';
import { Box, Button, Checkbox, Collapse, Container, Fab, FormControl, FormControlLabel, Grid, IconButton, InputLabel, Modal, Paper, Select, TextField, Typography } from '@material-ui/core';
import '../../../utils/api'
import { createUser, updateUser } from '../../../utils/api';
import { useAuth } from '../../../contexts/AuthContext';
import { DataGrid, GridColDef, GridRowSelectedParams, GridToolbarContainer, GridToolbarExport } from '@material-ui/data-grid';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Add } from '@material-ui/icons';
import DashboardPageStyles from '../DashboardPageStyles';
import CloseIcon from '@material-ui/icons/Close';
import { useData } from '../../../contexts/DataContext';

const columns: GridColDef[] = [
  { field: 'id', hide: true },
  { field: 'uid', headerName: 'ID', width: 150 },
  { field: 'displayName', headerName: 'Name', width: 250 },
  { field: 'phoneNumber', headerName: 'Phone', width: 150 },
  { field: 'email', headerName: 'Email', width: 250 },
  { field: 'role', headerName: 'Role', width: 150 },
  { field: 'trusted', headerName: 'Trusted', width: 130 },
  { field: 'lastSignInTime', headerName: 'Last Sign In', width: 250 },
];

function ExportToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

export default function Users() {
  const classes = DashboardPageStyles();
  const auth = useAuth();
  const data = useData();

  const [modalOpen, setModalOpen] = React.useState(false);
  const [userId, setUserId] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [role, setRole] = useState('');
  const [trusted, setTrusted] = useState(false);
  const [addUserFlag, setAddUserFlag] = useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertSuccess, setAlertSuccess] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState('');
  const [emailError, setEmailError] = React.useState(false);
  const [phoneError, setPhoneError] = React.useState(false);
  const [alertMessageTitle, setAlertMessageTitle] = React.useState('');

  const handleModalOpen = (addUser = false) => {
    setAddUserFlag(addUser);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setUserId('');
    setName('');
    setEmail('');
    setPhoneNumber('');
    setRole('');
    setTrusted(false);
    setEmailError(false);
    setPhoneError(false);
    setModalOpen(false);
  }

  const handleUpdateProfile = async (e: any) => {
    e.preventDefault();
    try {
      console.log(name, email, phoneNumber, role, trusted);
      if (name.trim() && email.trim() && phoneNumber.trim() && role) {
        const token = await auth?.currentUser?.getIdToken();
        if (token) {
          if (addUserFlag)
            createUser(token, email, name, phoneNumber, role, trusted);
          else
            updateUser(token, userId, email, name, phoneNumber, role, trusted)
        } else {
          throw new Error('Token error');
        }
        data?.refreshUserData();
        setAlert('Success', 'Profile Updated!');
      } else {
        setAlert('Error', 'Some fields are empty!', false);
      }
    } catch (e) {
      setAlert('Error', 'Something went wrong!! Please try again.', false);
      console.error(e);
    }
    handleModalClose();
  }

  const handleClick = (param: GridRowSelectedParams) => {
    setUserId(param.data.uid);
    setName(param.data.displayName);
    setPhoneNumber(param.data.phoneNumber);
    setRole(param.data.role);
    setTrusted(param.data.trusted);

    if (param.data.email)
      setEmail(param.data.email);
    else
      setEmail(param.data.phoneNumber.replace("+91", "") + "@meenachilriver.org")

    handleModalOpen();
  }

  const setAlert = (title: string, message: string, success = true) => {
    setAlertSuccess(success);
    setAlertMessage(message);
    setAlertMessageTitle(title);
    setOpenAlert(true);
  }

  return (
    <>
      <Collapse in={openAlert}>
        <Alert
          severity={alertSuccess ? "success" : "error"}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpenAlert(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <AlertTitle>{alertMessageTitle}</AlertTitle>
          {alertMessage}
        </Alert>
      </Collapse>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Title>Users</Title>
              {data?.usersListData ?
                <Box width='100%' style={{ height: '70vh' }}>
                  <DataGrid rows={data.usersListData} columns={columns} pageSize={20} autoHeight={true} onRowSelected={handleClick} components={{
                    Toolbar: ExportToolbar,
                  }} />
                </Box> : <p>Loading..</p>
              }
            </Paper>
          </Grid>
        </Grid>
        <Fab className={classes.fab} color="primary" aria-label="add" onClick={() => { handleModalOpen(true) }}>
          <Add />
        </Fab>
      </Container>
      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Container maxWidth="sm" className={classes.container}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h5">
              {addUserFlag ? "Create User" : "Update User"}
            </Typography>
            <form className={classes.form} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    autoComplete="fname"
                    name="firstName"
                    variant="outlined"
                    required
                    fullWidth
                    id="firstName"
                    label="Name"
                    autoFocus
                    value={name}
                    onChange={e =>
                      setName(e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    error={emailError}
                    variant="outlined"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    value={email}
                    onChange={e => {
                      (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/).test(e.target.value) ? setEmailError(false) : setEmailError(true);
                      setEmail(e.target.value)
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    error={phoneError}
                    variant="outlined"
                    required
                    fullWidth
                    id="phone"
                    label="Phone"
                    name="Phone"
                    autoComplete="phone"
                    value={phoneNumber}
                    inputProps={{ pattern: "^(\+\d{1,3})?\d{10}$" }}
                    onChange={e => {
                      (/^(\+\d{2})?\d{10}$/).test(e.target.value) ? setPhoneError(false) : setPhoneError(true);
                      setPhoneNumber(e.target.value)
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl>
                    <InputLabel htmlFor="outlined-role-native-simple">Role</InputLabel>
                    <Select
                      native
                      value={role}
                      inputProps={{
                        name: 'role',
                        id: 'outlined-role-native-simple',
                      }}
                      onChange={e => setRole(e.target.value as string || "")}
                      fullWidth
                    >
                      <option value="admin">Admin</option>
                      <option value="manager">Manager</option>
                      <option value="user">User</option>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={trusted}
                        onChange={e => setTrusted(e.target.checked)}
                        name="trustedCheck"
                        color="primary"
                      />
                    }
                    label="Trust User"
                  />
                </Grid>

              </Grid>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={phoneError || emailError}
                onClick={handleUpdateProfile}
              >
                {addUserFlag ? "Create" : "Update"}
              </Button>
            </form>
          </Paper>
        </Container>
      </Modal>
    </>
  );
}